<template>
    <div class="financeApplication__form__input financeApplication__form__input--radio" :class="{ 'financeApplication__form__input--active': isActive }">
        <input type="radio"
               :name="name"
               :value="radioValue"
               :id="id"
               :checked="isActive"
               :disabled="disabled"
               @change="onChange"
        />
        <label :for="id">{{ label }}</label>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
        },
        value: {
            type: [String, Number, Array, Boolean],
        },
        radioValue: {
            type: [String, Boolean],
            default: true,
        },
        id: {
            type: String
        },
        label: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onChange(e) {
            this.$emit('input', e.target.value)
        }
    },
    computed: {
        isActive() {
            return this.radioValue === this.value
        }
    }
}
</script>